import { useTranslation } from "react-i18next";
import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";



export const useGetParticipants = () => {

    const axios = useAxios();
    const { t } = useTranslation();

    const getParticipants = async () => {
        try {
            const response = await axios.get(`/api/users`);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.getParticipants"));
        }
    }

    return useQuery({queryKey: ["participants"], queryFn: getParticipants, staleTime: Infinity, gcTime: Infinity});
}